const initialState = {
    getToken: "",
  };
  
  const tokenReducer = (state = initialState, action) => {
    switch (action.type) {
      case 'SET_TOKEN':
        return {
          ...state,
          getToken: action.payload
        };
      default:
        return state;
    }
  };
  
  export default tokenReducer;